import Route from 'cio/routes/base';
import { ImportState } from 'cio/models/import';

export default class MapRoute extends Route {
  crumb() {
    let { import: model } = this.modelFor('segments.segment.imports.csv.setup');

    return {
      name: 'Map',
      path: 'segments.segment.imports.csv.setup.map',
      model,
    };
  }

  resetController(controller, isExiting) {
    super.resetController(...arguments);

    let model = this.modelFor(this.routeName);

    if (isExiting && model.hasDirtyAttributes) {
      model.rollbackAttributes();
    }
  }

  redirect(model) {
    if (model.state === ImportState.Failed) {
      return this.router.transitionTo('segments.segment.imports.csv.setup.index', model);
    }
  }
}
